/** 光速近似值（m/s），用于波长 fallback 展示 */
const SPEED_OF_LIGHT_MPS = 300_000_000;

/** ITU 业余频段（Hz 闭区间），标签与设备 freq_band_name 习惯一致 */
const HAM_BAND_RANGES: ReadonlyArray<{ minHz: number; maxHz: number; label: string }> = [
  { minHz: 135_700, maxHz: 137_800, label: '2200M' },
  { minHz: 472_000, maxHz: 479_000, label: '630M' },
  { minHz: 1_800_000, maxHz: 2_000_000, label: '160M' },
  { minHz: 3_500_000, maxHz: 4_000_000, label: '80M' },
  { minHz: 5_330_000, maxHz: 5_407_000, label: '60M' },
  { minHz: 7_000_000, maxHz: 7_300_000, label: '40M' },
  { minHz: 10_100_000, maxHz: 10_150_000, label: '30M' },
  { minHz: 14_000_000, maxHz: 14_350_000, label: '20M' },
  { minHz: 18_068_000, maxHz: 18_168_000, label: '17M' },
  { minHz: 21_000_000, maxHz: 21_450_000, label: '15M' },
  { minHz: 24_890_000, maxHz: 24_990_000, label: '12M' },
  { minHz: 28_000_000, maxHz: 29_700_000, label: '10M' },
  { minHz: 50_000_000, maxHz: 54_000_000, label: '6M' },
  { minHz: 70_000_000, maxHz: 70_500_000, label: '4M' },
  { minHz: 144_000_000, maxHz: 148_000_000, label: '2M' },
  { minHz: 222_000_000, maxHz: 225_000_000, label: '1.25M' },
  { minHz: 420_000_000, maxHz: 450_000_000, label: '0.7M' },
  { minHz: 902_000_000, maxHz: 928_000_000, label: '0.33M' },
];

function formatWavelengthBandLabel(freqHz: number): string {
  const lambdaM = SPEED_OF_LIGHT_MPS / freqHz;
  if (lambdaM >= 10) return `${Math.round(lambdaM)}M`;
  const rounded = Math.round(lambdaM * 100) / 100;
  return `${rounded}M`;
}

/** 由当前工作频率（Hz）得到业余习惯波段名，如 14_073_000 → 20M */
export function formatHamBandNameFromFrequency(freqHz?: number | null): string {
  if (freqHz == null || !Number.isFinite(freqHz) || freqHz <= 0) return '-';

  const match = HAM_BAND_RANGES.find((band) => freqHz >= band.minHz && freqHz <= band.maxHz);
  if (match) return match.label;

  return formatWavelengthBandLabel(freqHz);
}
